import React, { Component } from "react";
import Recaptcha from "react-google-invisible-recaptcha";

import api, { setErrors } from "@/middlewares/api";
import history from "@/store/history";
import { ROUTESLIST } from "@/static/urls";

import MainModal from "@/components/modals/main";
import BgDLImage from "@/assets/images/pages/digital_license_bg_img.jpg";
import WithSavedFile from "../../../components/hoc/with-saved-file";
import { v4 as uuidV4 } from "uuid";
import { addToCart } from "@/services/cart";

// import wizard
import DigitalLicenseWizard from "./features/Wizard";

const bgStyles = {
  backgroundImage: `url(${BgDLImage})`,
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center",
  backgroundSize: "cover",
};

class DigitalLicenseForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpenModal: false,
      sending: false,
      isOpenDisclaimer: false,
      isCheckedDisclaimer: false,
    };
    this.isRecaptcha = !!process.env.REACT_APP_RECAPTCHA_KEY;
    this.recaptchaKey = process.env.REACT_APP_RECAPTCHA_KEY;

    this.closeModal = this.closeModal.bind(this);
    this.openDisclaimer = this.openDisclaimer.bind(this);
    this.closeDisclaimer = this.closeDisclaimer.bind(this);
    this.disclaimerChange = this.disclaimerChange.bind(this);
    this.submitHandler = this.submitHandler.bind(this);
  }

  closeModal() {
    this.setState({ isOpenModal: false });
    history.push(ROUTESLIST.SUBSCRIPTIONS, { from: "digital-license" });
  }

  closeDisclaimer() {
    this.setState({ isOpenDisclaimer: false });
  }

  openDisclaimer() {
    this.setState({ isOpenDisclaimer: true });
  }

  disclaimerChange() {
    this.setState((prev) => ({
      isCheckedDisclaimer: !prev.isCheckedDisclaimer,
    }));
  }

  onRecaptchaResolved() {}

  recaptchaSubmit(data) {
    return new Promise((resolve, reject) => {
      this.recaptcha
        .execute()
        .then(() => {
          this.setState({ sending: true });
          api
            .post("digital-license", data)
            .then(() => {
              this.setState({ isOpenModal: true, sending: false });
              return resolve(null);
            })
            .catch((err) => {
              this.setState({ sending: false });
              if (err.response?.status === 422) {
                return reject(setErrors(err.response));
              }
            });
        })
        .catch(() => resolve(null));
    });
  }

  simpleSendData(data) {
    addToCart({
      ...data,
      id: uuidV4(),
      plan_name: "Digital License",
      price: 400,
      plan_description: "Digital License",
      priceId: "price_1RC11pDOERxX1mfPQkjIqwMA",
      product_type: "license",
    });
    this.props.history.push(ROUTESLIST.CHECKOUT, { from: "digital-license" });
  }

  submitHandler(data) {
    if (!this.state.isCheckedDisclaimer) return;
    if (this.isRecaptcha) {
      return this.recaptchaSubmit(data);
    } else {
      data["raw_audio"] = this.props.getRawFileData();
      return this.simpleSendData(data);
    }
  }

  render() {
    const { isOpenModal, sending, isOpenDisclaimer, isCheckedDisclaimer } =
      this.state;
    const { isRecaptcha, recaptchaKey } = this;

    return (
      <main className="page upload-page">
        <section className="upload-form__sec" style={bgStyles}>
          <div className="content">
            <div className="upload-form__top">
              <h2 className="head-shadow">Digital License</h2>
              <h3 className="head">
                LICENSES TO REMAKE SONGS AND SHOOT VISUALS
              </h3>
              <div className="upload-form__top-msg form-layout">
                <p>
                  Easily secure the rights you need to legally remake songs and
                  create music videos—fast, simple, and hassle-free.
                </p>
              </div>
            </div>

            {/* Wizard per step */}
            <DigitalLicenseWizard
              onSubmit={this.submitHandler}
              sending={sending}
              isCheckedDisclaimer={isCheckedDisclaimer}
              openDisclaimer={this.openDisclaimer}
            />
          </div>
        </section>

        {isRecaptcha && (
          <Recaptcha
            style={{ display: "none" }}
            ref={(ref) => (this.recaptcha = ref)}
            sitekey={recaptchaKey}
            onResolved={this.onRecaptchaResolved}
          />
        )}

        {/* Modal Success */}
        <MainModal open={isOpenModal} onClose={this.closeModal}>
          <h4 className="main-modal__big-head">YOUR REQUEST IS SENT</h4>
          <p className="main-modal__subhead">
            WE WILL BE IN TOUCH WITH YOU WITHIN A HOUR
          </p>
          <div className="main-modal__act">
            <button
              className="btn btn-primary"
              type="button"
              onClick={this.closeModal}
            >
              OK
            </button>
          </div>
        </MainModal>

        {/* Modal Disclaimer */}
        <MainModal open={isOpenDisclaimer} onClose={this.closeDisclaimer}>
          <p className="main-modal__msg single">
            The content of our digital license reports are for informational
            purposes only and should not be taken as legal advice. Such content
            is based solely upon information provided to us and/or our internal
            professional analysis. Your reliance on any such content shall be
            solely at your own risk.
          </p>
          <p className="main-modal__msg single">
            <label className="checkbox-field">
              <input
                type="checkbox"
                className="checkbox-field__input"
                checked={isCheckedDisclaimer}
                onChange={this.disclaimerChange}
              />
              <span className="checkbox-field__control" />
              <span className="checkbox-field__label">I accept</span>
            </label>
          </p>
          <div className="main-modal__act">
            <button
              className="btn btn-primary"
              type="button"
              onClick={this.closeDisclaimer}
            >
              OK
            </button>
          </div>
        </MainModal>
      </main>
    );
  }
}

export default WithSavedFile(DigitalLicenseForm);